import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Item from './item';
import LoaderItem from './loader-item';
export default class Items extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isLoaderShown: false
    });
    _defineProperty(this, "handleLoaderComplete", () => {
      this.setState({
        isLoaderShown: false
      });
    });
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.items && !prevState.isLoaderShown) {
      return {
        isLoaderShown: true
      };
    }
    return null;
  }
  renderLoader() {
    const {
      depth,
      items,
      loadingLabel
    } = this.props;
    return /*#__PURE__*/React.createElement(LoaderItem, {
      isCompleting: !!(items && items.length),
      onComplete: this.handleLoaderComplete,
      depth: depth + 1,
      loadingLabel: loadingLabel
    });
  }
  renderItems() {
    const {
      render,
      items,
      loadingLabel,
      depth = 0
    } = this.props;
    return items && items.map((itemData, index) => /*#__PURE__*/React.createElement(Item, {
      data: itemData,
      depth: depth + 1,
      key: itemData && itemData.id || index,
      render: render,
      loadingLabel: loadingLabel
    }));
  }
  render() {
    const {
      isLoaderShown
    } = this.state;
    return isLoaderShown ? this.renderLoader() : this.renderItems();
  }
}
_defineProperty(Items, "defaultProps", {
  depth: 0
});